// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"intakeForm_wrapper__9tQEK","leftSide":"intakeForm_leftSide__1l-PI","footer":"intakeForm_footer__1JAQl"};